import { render, staticRenderFns } from "./VWIDBuzzDisclosure.vue?vue&type=template&id=f9b5a770&"
import script from "./VWIDBuzzDisclosure.vue?vue&type=script&lang=js&"
export * from "./VWIDBuzzDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports